import "./css/ImageButton.css";

import { ButtonBase } from "@mui/material";

import { disableInput } from "./Utility";

type ImageButtonProps = {
  source: string;
  text?: string | undefined;
  onClick?: () => void;
  disabled?: boolean;
  hidden?: boolean;
};

export const ImageButton: React.FC<ImageButtonProps> = ({ source, text, onClick, ...rest }) => {
  return (
    <ButtonBase
      className={text ? "imageButton_WithText supportsRtl" : "imageButton"}
      onMouseDown={disableInput}
      onTouchStart={disableInput}
      onClick={rest.disabled ? undefined : onClick}
      {...rest}
    >
      <img className={text ? "imageButtonImage_WithText" : "imageButtonImage"} src={source} draggable={false} />
      {text && <div className="BoldText">{text}</div>}
    </ButtonBase>
  );
};
